import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { createApp, h, ref, type App } from 'vue';
import FirstTaskRewardPrompt from '../components/FirstTaskRewardPrompt.vue';
import type { FirstTaskRewardAction } from '../first-task-reward-api';
import type {
    FirstTaskRewardPresenter,
    FirstTaskRewardPromptHandle,
    FirstTaskRewardPromptOptions,
} from '../first-task-reward-presenter';

/** 将权益卡片动态挂载到 document.body。 */
@injectable()
export class FirstTaskRewardPresenterImpl implements FirstTaskRewardPresenter {
    showPrompt(options: FirstTaskRewardPromptOptions): FirstTaskRewardPromptHandle {
        const host = document.createElement('div');
        host.dataset.testid = 'first-task-reward-prompt-host';
        let app: App<Element> | undefined;
        let disposed = false;
        const loadingAction = ref<FirstTaskRewardAction>();
        const previousOverflow = document.body.style.overflow;

        const dispose = () => {
            if (disposed) return;
            disposed = true;
            document.removeEventListener('keydown', handleKeydown);
            app?.unmount();
            host.remove();
            document.body.style.overflow = previousOverflow;
        };
        const dismiss = () => {
            dispose();
            options.onDismiss();
        };
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') dismiss();
        };

        try {
            document.body.appendChild(host);
            // eslint-disable-next-line vue/one-component-per-file
            app = createApp(() => h(FirstTaskRewardPrompt, {
                ...options,
                loadingAction: loadingAction.value,
                onAction: options.onAction,
                onDismiss: dismiss,
            }));
            app.mount(host);
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', handleKeydown);
        } catch (error) {
            dispose();
            throw error;
        }
        return {
            dispose,
            setActionLoading(action?: FirstTaskRewardAction) {
                if (disposed) return;
                loadingAction.value = action;
            },
        };
    }

}
